/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { DATAITEM_TYPE_DIMENSION } from 'constants';

import { DATAITEM_TYPE_DERIVED_DIMENSION } from '../../Setup/constants/constants';

/**
  * @param  {Array<Object>} entityTypes
  * [{
      "name": "TestDeviceType110",
      "dataItemDto": [
        {
          "name": "name",
          "type": "METRIC",
          "columnName": "name",
          "columnType": "literal",
          "sourceTableName": null
        },
      ]
    }]
   *
  * @return {Array<Object>}
  *  name: PropTypes.string,
  * dimensionNames: PropTypes.arrayOf(PropTypes.string),
  * metricNames: PropTypes.arrayOf(PropTypes.string),
  * createdBy: PropTypes.string,
  * via: PropTypes.string,
  * lastUpdated: PropTypes.number,
  * dataItems: PropTypes.number,
  * rules: PropTypes.number,
*/
export const formatEntityTypes = entityTypes =>
  entityTypes.map
    ? entityTypes.map(entityType => ({
        ...entityType,
        dimensionNames: entityType.dataItemDto
          ? entityType.dataItemDto
              .filter(
                dataItem =>
                  dataItem.type === DATAITEM_TYPE_DIMENSION ||
                  dataItem.type === DATAITEM_TYPE_DERIVED_DIMENSION
              )
              .map(dataItem => dataItem.name)
          : [],
        metricNames: entityType.dataItemDto
          ? entityType.dataItemDto
              .filter(
                dataItem =>
                  dataItem.type !== DATAITEM_TYPE_DIMENSION &&
                  dataItem.type !== DATAITEM_TYPE_DERIVED_DIMENSION
              )
              .map(dataItem => dataItem.name)
          : [],
        dataItems: entityType.dataItemDto?.length || 0,
      }))
    : [];
